/**
 * Saves data to localStorage with the specified key
 * @param key - The key to store the data under
 * @param value - The value to store
 */
export function setStorageItem<T>(key: string, value: T) {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    // NOTE: Handle error for browser that doesn't support localStorage
    console.error(`Error saving to localStorage: ${error}`);
  }
}

/**
 * Retrieves data from localStorage for the specified key
 * @param key - The key to retrieve data for
 * @param defaultValue - Optional default value to return if key doesn't exist
 * @returns The stored value or defaultValue if not found
 */
export function getStorageItem<T>(key: string, defaultValue?: T) {
  try {
    const item = localStorage.getItem(key);
    if (item === null) {
      return defaultValue ?? null;
    }
    return JSON.parse(item) as T;
  } catch (error) {
    // NOTE: Handle error for browser that doesn't support localStorage
    console.error(`Error retrieving from localStorage: ${error}`);
    return defaultValue ?? null;
  }
}
